import React from "react";

import { CloseIcon } from "../utils/components/icons";

export const ModalLayout = (props) => {
  let { modalName, title, children, id, size } = props;
  modalName = modalName || id || "flipFlopp";
  size = size || "lg";
  return (
    <div className="bootstrap-iso">
      <div className="modal fade" id={modalName} tabIndex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="false" data-bs-backdrop="static">
        <div className={"modal-dialog modal-" + size} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold text-gray" id="modalLabel">
                {title}
              </h3>
              <button type="button"
                className="btn btn-default ser-close-modal"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <CloseIcon></CloseIcon>
              </button>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
